"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apis = void 0;
exports.apis = [
    "contact.chooseContact",
    "userinfo.getUserInfo",
    "userinfo.enterProfile",
    "chat.chooseChat",
    "chat.enterChat",
    "chat.getChatInfo",
    "chat.toggleChat",
    "chat.sendMessageCard",
    "link.openApp",
    "link.openMiniProgram",
    "link.openWebApp",
    "link.openChat",
    "link.openCalendar",
    "link.openCalendarView",
    "link.openCalendarCreate",
    "link.openCalendarAccount",
    "link.openTodo",
    "link.openTodoCreate",
    "link.openTodoDetail",
    "link.openTodoView",
    "link.openDocs",
    "link.openBot",
    "link.openSSO",
    "link.openWebView",
    "clipboard.getClipboardData",
    "clipboard.setClipboardData",
    "file.docsPicker",
    "file.filePicker",
    "file.saveFile",
    "file.openDocument",
    "file.getFileSystemManager",
    "image.chooseImage",
    "image.compressImage",
    "image.getImageInfo",
    "image.previewImage",
    "image.saveImageToPhotosAlbum",
    "video.chooseVideo",
    "video.saveVideoToPhotosAlbum",
    "video.chooseMedia",
    "location.chooseLocation",
    "location.getLocation",
    "location.openLocation",
    "location.startLocationUpdate",
    "location.stopLocationUpdate",
    "location.onLocationChange",
    "vibrate.vibrateLong",
    "vibrate.vibrateShort",
    "deviceCredential.startDeviceCredential",
    "navigation.openSchema",
    "navigation.close",
    "system.getSystemInfo",
    "system.getDeviceID",
    "network.getNetworkType",
    "network.downloadFile",
    "network.getNetworkQualityType",
    "network.onNetworkQualityChange",
    "screenBrightness.setKeepScreenOn",
    "screenBrightness.getScreenBrightness",
    "screenBrightness.setScreenBrightness",
    "setting.getSetting",
    "setting.openSetting",
    "setting.authorize",
    "ui.showToast",
    "ui.showActionSheet",
    "ui.showModal",
    "ui.showPrompt",
    "ui.hideToast",
    "captureScreen.onUserCaptureScreen",
    "captureScreen.offUserCaptureScreen",
    "record.getRecorderManager",
    "verify.startPasswordVerify",
    "watermark.checkWatermark",
    "mail.mailto",
    "wifi.getConnectedWifi",
    "wifi.getWifiStatus",
    "wifi.getWifiList",
    "wifi.onGetWifiList",
    "wifi.offGetWifiList",
    "wifi.offGetWifiList",
    "wifi.offGetWifiList",
    "accelerometer.startAccelerometer",
    "accelerometer.stopAccelerometer",
    "accelerometer.onAccelerometerChange",
    "compass.startCompass",
    "compass.stopCompass",
    "bluetooth.closeBluetoothAdapter",
    "bluetooth.getBluetoothAdapterState",
    "bluetooth.getBluetoothDevices",
    "bluetooth.onBluetoothAdapterStateChange",
    "bluetooth.onBluetoothDeviceFound",
    "bluetooth.startBluetoothDevicesDiscovery",
    "bluetooth.openBluetoothAdapter",
    "bluetooth.stopBluetoothDevicesDiscovery",
    "beacon.startBeaconDiscovery",
    "beacon.closeBluetoothAdapter",
    "beacon.getBeacons",
    "beacon.onBeaconUpdate",
    "beacon.offBeaconUpdate",
    "beacon.onBeaconServiceChange",
    "beacon.offBeaconServiceChange",
    "phone.makePhoneCall",
    "scanCode",
    "disconnectBLEDevice",
    "getBLEDeviceCharacteristics",
    "getBLEDeviceServices",
    "getNFCAdapter",
    "notifyBLECharacteristicValueChange",
    "onBLECharacteristicValueChange",
    "readBLECharacteristicValue",
    "writeBLECharacteristicValue"
];
//# sourceMappingURL=data:application/json;base64,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